import { GlobalData } from "./GlobalData";

export class Ajax {
    public static invoke(urlSuffix: string, type: string, data?: any,
        success?: (data: any, textStatus: string, jqXHR: JQueryXHR) => any,
        error?: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => any,
        complete?: (jqXHR: JQueryXHR, textStatus: string) => any):
        JQueryPromise<any> {

        let jsonData = '';
        if (data) {
            jsonData = JSON.stringify(data);
        }

        const settings: JQueryAjaxSettings = {
            url: GlobalData.URL_BASE + urlSuffix,
            dataType: 'json',
            type: type,
            data: jsonData,
            contentType: 'application/json;charset=utf-8',
            success: success,
            error: error,
            complete: complete,
            timeout: 0,
        };

        return $.ajax(settings);
    }
}
